<button
  type="button"
  class="atlas-btn atlas-btn-default btn-sm wl-add-attendee-btn"
  (click)="handleNewAttendeeClick()"
  [hidden]="!enableNewButton"
>
  <span class="glyphicon glyphicon-plus mr-5"></span>
  {{ 'events.registration.wizard.attendees.new-attendee-button-label' | translate | titlecase }}
</button>

<ul class="list-unstyled wl-attendee-links">
  <li *ngFor="let attendee of attendees; let attendeeIndex = index" class="wc-truncate-ellipsis">
    <a
      href="#"
      (click)="$event.preventDefault(); handleAttendeeLinkClick(attendeeIndex)"
      [title]="
        attendee.FName || attendee.LName
          ? attendee.FName + ' ' + attendee.LName
          : ('events.registration.wizard.attendees.attendee-tab-prefix' | translate | titlecase) + (attendeeIndex + 1)
      "
    >
      <span [hidden]="!attendee.FName && !attendee.LName">{{ attendee.FName }} {{ attendee.LName }}</span>
      <span [hidden]="attendee.FName || attendee.LName"
        >{{ 'events.registration.wizard.attendees.attendee-tab-prefix' | translate | titlecase }}{{ attendeeIndex + 1 }}</span
      >
    </a>
  </li>
</ul>
